import {
  MatchPageController
} from '../../MatchPage';

export default async function onSelectMatch(selectedMatch) {
  if (!!selectedMatch.id) {
    MatchPageController().setState({ selectedMatch });
  }
}
